import { Grid, Typography, useTheme } from '@material-ui/core';
import React from 'react';
import { useAssets, useLocale, useUser } from 'hooks';
import { useHistory } from 'react-router-dom';

import { Asset, Button, IconTile, Loader, TabMenu } from 'ui';
import { AccountIcon, QrIcon } from 'ui/icons';
import { AppRoute } from 'routing/AppRoute.enum';
import { DashboardProps } from '../Dashboard.types';
import { useStyles } from '../Dashboard.styles';
import { AssetStatuses } from 'hooks/useAssets/useAssets.types';

export const ManufacturerDashboard = ({ isError, fetchTokens, isLoading }: DashboardProps) => {
  const { formatMessage } = useLocale();
  const { push } = useHistory();
  const theme = useTheme();
  const { assets } = useAssets();
  const { user } = useUser();
  const classes = useStyles();

  const renderConfirm = () => (
    <Grid container spacing={1}>
      <Grid item xs={6}>
        <IconTile
          icon={<QrIcon color="primary" />}
          title={formatMessage({ id: 'dashboard.scan_qr' })}
          color={theme.palette.primary.main}
          onClick={() => push(AppRoute.issueAsset)}
          iconFullSize
        />
      </Grid>
      <Grid item xs={6}>
        <IconTile
          icon={<AccountIcon color="primary" />}
          title={formatMessage({ id: 'dashboard.approve_user' })}
          color={theme.palette.primary.main}
          onClick={() => push(AppRoute.approveAssetOwner)}
          iconFullSize
        />
      </Grid>
    </Grid>
  );

  const renderBatteries = () => {
    if (isError) {
      return (
        <Grid container justify="center" direction="column" alignItems="center">
          <Typography className={classes.errorTitle}> {formatMessage({ id: 'dashboard.error' })}</Typography>
          <Button variant="contained" color="primary" onClick={fetchTokens}>
            {formatMessage({ id: 'dashboard.fetch_assets' })}
          </Button>
        </Grid>
      );
    }

    return isLoading || !assets ? (
      <Grid container justify="center" direction="column" alignItems="center">
        <Loader text={formatMessage({ id: 'dashboard.assetsLoading' })} />
      </Grid>
    ) : (
      <Grid container spacing={1}>
        {assets
          .filter(asset => asset.status === AssetStatuses.ISSUED && asset.manufacturer?.address === user?.address)
          .map(({ id, name, status, subtitle }) => (
            <Grid key={id} item xs={6}>
              <Asset
                id={id}
                name={name}
                status={status}
                subtitle={subtitle}
                handleRecycle={() => null}
                handleSetting={() => null}
                handleTerminate={() => null}
              />
            </Grid>
          ))}
      </Grid>
    );
  };

  return (
    <TabMenu
      tabs={[
        {
          label: formatMessage({ id: 'dashboard.issue_batteries' }),
          content: renderConfirm(),
        },
        {
          label: formatMessage({ id: 'dashboard.your_batteries' }),
          content: renderBatteries(),
        },
      ]}
    />
  );
};
